import { getProfile } from "../storage/profile";
export function completionFeedback() {
	void getProfile()
		.then((profile) => {
			if (!profile.sound) return;
			try {
				const audio = new AudioContext();
				const osc = audio.createOscillator(),
					gain = audio.createGain();
				osc.connect(gain);
				gain.connect(audio.destination);
				osc.frequency.value = 660;
				gain.gain.setValueAtTime(0.04, audio.currentTime);
				gain.gain.exponentialRampToValueAtTime(0.001, audio.currentTime + 0.1);
				osc.start();
				osc.stop(audio.currentTime + 0.12);
				osc.onended = () => void audio.close();
			} catch {}
		})
		.catch(() => {});
	try {
		navigator.vibrate?.(20);
		const target = document.querySelector<HTMLElement>('[role="status"]');
		target?.setAttribute("data-save-confirm", "");
		window.setTimeout(() => target?.removeAttribute("data-save-confirm"), 400);
	} catch {
		/* Feedback cannot block local saving. */
	}
}
